export default __webpack_public_path__ + "static/N0272-0b032aba6975a12d58f90a0e0171cdb0.png";